import { NavigateFunction, NavigateOptions, To } from 'react-router-dom';

let navigate: NavigateFunction | null = null;

export const setNavigate = (navFn: NavigateFunction) => {
  navigate = navFn;
};

export const redirectTo = (to: To, options?: NavigateOptions) => {
  if (navigate) {
    navigate(to, options);
  } else {
    console.warn('Navigate function is not set yet.');
  }
};
